import gmCrypt from 'gm-crypt';
// key
// 正式   4ujythg34645unr8
// 测试   0123456789abcdef
// iv
// 正式   678554refgn5t45k
// 测试   0123456789abcdef
let gmCryptConfig = {
  key: "4ujythg34645unr8", //这里这个key值要与后端的一致，后端解密是根据这个key
  mode: "cbc", // 加密的方式，ecb和cbc两种，也是看后端如何定义的，不过要是cbc的话下面还要加一个iv的参数，ecb不用
  iv: "678554refgn5t45k",
  cipherType: "base64"
};
// eslint-disable-next-line new-cap
const sm4Util = new gmCrypt.sm4(gmCryptConfig); // new一个sm4函数，将上面的gmCryptConfig作为参数传递进去
// 定义sm4加密方法
function encryptText(text) {
  return sm4Util.encrypt(text);
}
// 定义解密方法
function decryptText(text) {
  return JSON.parse(sm4Util.decrypt(text));
}
export default {
  encrypt: encryptText,
  decrypt: decryptText
}
